import useMergeRecords from "../../../../api/api-hooks/records/useMergeRecords";
import useRecord from "../../../../api/api-hooks/records/useRecord";
import useFieldMap from "../../../../hooks/useFieldMap";
import { Module } from "../../../../types/TenantInterfaces";
import MergeItemsDrawer from "../../MergeItemsDrawer";

interface Props {
  open: boolean;
  onClose: () => void;
  onMerge: () => void;
  records: Record<string, any> | undefined;
  module: Module | undefined | null;
}

const MergeRecordsDrawerWrapper = (props: Props) => {
  if (props?.records?.length !== 2) return null;

  return <MergeRecordsDrawer {...props} />;
};

const MergeRecordsDrawer = ({
  open,
  onClose,
  onMerge,
  records,
  module,
}: Props) => {
  const fieldMap = useFieldMap(module?.APIName);
  const recordOneID = records?.[0]?.id || records?.[0]?._id;
  const recordTwoID = records?.[1]?.id || records?.[1]?._id;

  const { record: record1, recordLoading: loading1 } = useRecord({
    moduleAPIName: module?.APIName,
    recordID: recordOneID,
    enabled: open,
  });
  const { record: record2, recordLoading: loading2 } = useRecord({
    moduleAPIName: module?.APIName,
    recordID: recordTwoID,
    enabled: open,
  });

  const { mergeRecords, mergingRecords, mergeRecordsError, clearError } =
    useMergeRecords();

  return (
    <MergeItemsDrawer
      open={open}
      module={module}
      fieldMap={fieldMap}
      onClose={onClose}
      onMerge={handleMerge}
      itemOne={record1}
      itemTwo={record2}
      loading={loading1 || loading2}
      submitting={mergingRecords}
      error={
        mergeRecordsError
          ? { message: mergeRecordsError, onClear: clearError }
          : undefined
      }
    />
  );

  function handleMerge({
    moduleAPIName,
    payload,
    onSuccess,
  }: {
    moduleAPIName: string;
    payload: any;
    onSuccess: any;
  }) {
    mergeRecords({
      moduleAPIName: moduleAPIName,
      payload: payload,
      onSuccess: () => {
        onMerge();
        onSuccess();
      },
    });
  }
};

export default MergeRecordsDrawerWrapper;
